import 'Plugins/filteringPlugin';

export default function initFiltering(data) {
	const lastClass = 'last-visible-item';

	jQuery('.search-section').filteringItems({
		container: '.card-wrapp',
		items: '.address-card',
		filterLinks: '[data-filter]',
		onInit: function() {
			this.mapAPI = this.holder.find('.mapbox-holder').data('Mapbox');
			this.title = this.holder.find('.search-title h3');
		},
		onFilter: function(items, filters) {
			const filterItems = data.filter((item) => {
				return item.category.includes(filters.type[0]);
			});

			this.items.removeClass(lastClass);

			setTimeout(() => {
				if (this.mapAPI) {
					this.mapAPI.removeMarkers();
					this.mapAPI.prepareMarkers(filterItems);
				}
			});

			const visibleItems = items.filter(':visible');

			visibleItems.eq(visibleItems.length - 1).addClass(lastClass);
		},
		onChangeFilter: function(link) {
			this.title.text(link.text());
		}
	});
}